import { useQuery } from "@tanstack/vue-query";
import { storeToRefs } from "pinia";

import { useCreditReport, useOutcomeStore } from "@/stores";

export function useCreditProfile() {
  const creditReportStore = useCreditReport();

  const { isPositive } = storeToRefs(useOutcomeStore());


  const query = useQuery({
    queryKey: ['creditProfile'],
    queryFn: () => creditReportStore.getCreditProfile(),
    staleTime: 5 * 60 * 1000, // 5 minutes
    retry: 2, // Retry up to 3 times on failure
    enabled: isPositive,
  });

  return query;
}